import { createDecorator } from "vue-class-component";
import { assert } from "@leavy/utils";
/**
 * Declares the method as loadable task.
 * <br>
 * <br>Before the execution of the method, the loader of the component will be incremented. After the execution, it will be decremented.
 * <br>Async functions are, of course, supported, as it is the primary use case of the loader.
 */
export const LoaderTask = createDecorator((options, key) => {
    if (typeof options[key] === "function") {
        const func = options[key];
        options[key] = function (...args) {
            return this.$loader.task(() => func.apply(this, args));
        };
    }
    else if (options.methods && typeof options.methods[key] === "function") {
        const func = options.methods[key];
        assert(func);
        options.methods[key] = function (...args) {
            return this.$loader?.task(() => func.apply(this, args));
        };
    }
    else {
        throw new Error("This decorator only works on methods!");
    }
});
//# sourceMappingURL=decorators.js.map